import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { AddressLookupContainer } from '../containers/AddressLookupContainer.js';

const AddressLookup = (props)=>/*#__PURE__*/ React__default.createElement(AddressLookupContainer, swcHelpers.extends({}, props))
;

export { AddressLookup };
//# sourceMappingURL=AddressLookup.js.map
